// src/components/RegisterSuccess.jsx
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const ACCENT = "#2F7D32";
const NAVY = "#0F1E3D";

export default function RegisterSuccess() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const user = state?.user || null;
  const placement = state?.placement || null;

  // If user refreshes directly (state empty)
  if (!user) {
    return (
      <div className="pr-page">
        <style>{styles}</style>
        <div className="pr-success-wrap">
          <div className="pr-success-card">
            <div className="pr-success-icon" style={{ background: "#dc2626", boxShadow: "0 8px 22px rgba(220,38,38,.35)" }}>⚠</div>
            <h2 className="pr-success-title">Session Expired</h2>
            <p className="pr-success-sub">Please register again.</p>

            <div className="pr-success-btns" style={{ display: "block", marginTop: 24 }}>
              <button
                className="pr-btn-primary"
                onClick={() => navigate("/register", { replace: true })}
                style={{ width: "100%" }}
              >
                Go to Register
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pr-page">
      <style>{styles}</style>
      <div className="pr-success-wrap">
        <div className="pr-success-card">
          <div className="pr-success-icon">✓</div>
          <h2 className="pr-success-title">Registration Successful!</h2>
          <p className="pr-success-sub">
            {state?.msg || "User registered and placed successfully"}
          </p>

          <div className="pr-success-details">
            {[
              ["Name", user?.name],
              ["User ID", user?.userID || user?.userId],
              ["Mobile", user?.phone],
              ["Email", user?.email],
              ["User Type", (user?.userType || "TRAINEE_ENTREPRENEUR").replace(/_/g, " ")],
              ["Referred By", placement ? `${placement.parentName || user?.referralCode || ""} (${placement.parentId || ""})` : null],
              ["Placed Under", placement?.placedUnderUserID || placement?.parentId || null],
              ["Position", placement?.position],
            ]
              .filter(([, v]) => v)
              .map(([k, v]) => (
                <div key={k} className="pr-detail-row">
                  <span className="pr-detail-key">{k}</span>
                  <span className="pr-detail-val">{v}</span>
                </div>
              ))}
          </div>

          <div className="pr-success-btns">
            <button className="pr-btn-outline" onClick={() => navigate("/login", { replace: true })}>
              + Login Now
            </button>
            <button className="pr-btn-primary" onClick={() => navigate("/", { replace: true })}>
              ← Go Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = `
  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }
  html, body, #root { min-height: 100%; }
  body {
    font-family: 'Segoe UI', ui-sans-serif, system-ui, sans-serif;
    background: #f0f2f5;
    color: #0f172a;
  }
  input, button, select, textarea { font-family: inherit; }

  @keyframes popIn {
    from { opacity: 0; transform: scale(.94); }
    to   { opacity: 1; transform: scale(1); }
  }

  /* PAGE */
  .pr-page {
    min-height: 100vh;
    background: #f0f2f5;
  }

  /* SUCCESS */
  .pr-success-wrap {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px 16px;
    background: #f0f2f5;
  }
  .pr-success-card {
    background: #fff;
    border-radius: 20px;
    border: 1px solid rgba(0,0,0,.07);
    box-shadow: 0 12px 40px rgba(0,0,0,.10);
    padding: 36px 28px;
    max-width: 460px;
    width: 100%;
    text-align: center;
    animation: popIn .32s ease both;
  }
  .pr-success-icon {
    width: 64px; height: 64px;
    border-radius: 50%;
    background: linear-gradient(135deg, ${ACCENT} 0%, #1e5e26 100%);
    display: grid;
    place-items: center;
    font-size: 28px;
    color: #fff;
    margin: 0 auto 18px;
    box-shadow: 0 8px 22px rgba(47,125,50,.35);
  }
  .pr-success-title {
    font-size: 21px;
    font-weight: 900;
    color: ${NAVY};
    margin-bottom: 8px;
  }
  .pr-success-sub {
    font-size: 14px;
    color: #64748b;
    line-height: 1.6;
    margin-bottom: 20px;
  }
  .pr-success-details {
    background: #f8fafc;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    overflow: hidden;
    margin-bottom: 24px;
    text-align: left;
  }
  .pr-detail-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 14px;
    border-bottom: 1px solid #f1f5f9;
    gap: 12px;
  }
  .pr-detail-row:last-child { border-bottom: none; }
  .pr-detail-key { font-size: 13px; font-weight: 600; color: #64748b; }
  .pr-detail-val { font-size: 13px; font-weight: 800; color: ${NAVY}; text-align: right; }
  .pr-success-btns { display: flex; gap: 12px; }
  .pr-btn-outline {
    flex: 1; height: 44px;
    border-radius: 10px;
    border: 1.5px solid ${ACCENT};
    background: rgba(30,204,176,.07);
    color: #0a6b5c;
    font-weight: 800;
    font-size: 14px;
    cursor: pointer;
    transition: background .15s;
  }
  .pr-btn-outline:hover { background: rgba(30,204,176,.13); }
  .pr-btn-primary {
    flex: 1; height: 44px;
    border-radius: 10px;
    border: none;
    background: ${NAVY};
    color: #fff;
    font-weight: 800;
    font-size: 14px;
    cursor: pointer;
    transition: opacity .15s;
  }
  .pr-btn-primary:hover { opacity: 0.87; }

  /* MOBILE */
  @media (max-width: 500px) {
    .pr-success-card { padding: 28px 18px; }
    .pr-success-btns { flex-direction: row; gap: 8px; }
    .pr-btn-outline, .pr-btn-primary { font-size: 13px; padding: 0 4px; height: 44px; display: flex; align-items: center; justify-content: center; text-align: center; }
  }
`;